module.exports = __webpack_public_path__ + "img/hamster.be5030ca.webp";